module.exports = __webpack_public_path__ + "img/parter-logo-5.aeee70fe.png";